import { Utilities_Types } from './Utilities.frontend.types'

export namespace SalesOrders_Types {
  /**
   * Footprint custom field
   */
  export interface CustomField {
    Name?: string;
    Value?: string;
  }
  /**
   * Metadata for Footprint Orders database table
   */
  export interface Order {
    AccountId?: number;
    BackOrder?: boolean;
    BillingAddresId?: number;
    CancelThresholdDate?: any;
    ContainsPortalVisibleAttachments?: boolean;
    CreatedSysDateTime?: any;
    CreatedSysUser?: string;
    CurrencyId?: number;
    Exported?: boolean;
    ExternalLabel?: string;
    FulfillmentDate?: any;
    Id?: number;
    IntegrationHubId?: string;
    IntegrationHubSourceId?: string;
    IntegrationHubSourceLookupCode?: string;
    IntegrationHubSourcePlatform?: string;
    LookupCode?: string;
    MasterOrderId?: number;
    ModifiedSysDateTime?: any;
    ModifiedSysUser?: string;
    Notes?: string;
    OrderClassId?: number;
    OrderStatusId?: number;
    OutboundPriorityId?: number;
    OwnerReference?: string;
    ParentOrderId?: number;
    PreferredCarrierId?: number;
    PreferredCarrierServiceTypeId?: number;
    PreferredWarehouseId?: number;
    ProjectId?: number;
    ReadyToExport?: boolean;
    ReadyToExportBy?: string;
    ReadyToExportDate?: any;
    RequestedDeliveryDate?: any;
    ShippingAddressId?: number;
    ThirdPartyWarehouseId?: number;
    TotalCost?: number;
    TotalPrice?: number;
    VendorReference?: string;
  }
  /**
   * Metadata for Footprint OrderLines database table
   */
  export interface OrderLine {
    AllocationStrategyId?: number;
    AllocationStrategyWorkflowId?: any;
    Amount?: number;
    Color?: string;
    Cost?: number;
    CreatedSysDateTime?: any;
    CreatedSysUser?: string;
    DueDate?: any;
    EstablishmentIdentifier?: string;
    ExpectedLpContainerType?: number;
    ExpectedLpLookupCode?: string;
    ExpectedPackageAmount?: number;
    ExpectedPackageId?: number;
    GrossWeight?: number;
    HasChildren?: boolean;
    LicensePlateId?: number;
    LineNumber?: number;
    LotId?: number;
    Marks?: string;
    MaterialAlias?: string;
    MaterialId?: number;
    MaterialTransferSourceLineId?: number;
    ModifiedSysDateTime?: any;
    ModifiedSysUser?: string;
    NetWeight?: number;
    Notes?: string;
    OrderId?: number;
    PackageAllocationStrategyId?: number;
    PackagedAmount?: number;
    PackagedId?: number;
    ParentLineNumber?: number;
    Price?: number;
    PurchaseOrderIdentifier?: string;
    QualityControlNotes?: string;
    QualityControlRequired?: boolean;
    QualityControlStatus?: string;
    ResidueHoldIdentifier?: string;
    SerialNumberId?: number;
    ShipmentId?: number;
    ShippingAddressId?: number;
    Size?: string;
    StatusId?: number;
    Style?: string;
    TotalCost?: number;
    TotalPrice?: number;
    VendorLotId?: number;
    WeightTolerancePercentage?: number;
    WeightUomId?: number;
  }
  /**
   * Holds the custom state values for sales orders.
   */
  export enum e_order_status {
    Created = 1,
    Processed = 2,
    WaveCreated = 3,
    WaveProcessed = 4
  }
  /**
   * Footprint OrderLine object
   */
  export interface i_order_line_object {
    AllocationStrategy?: { EnumName?: string, Id?: number, Name?: string };
    AllocationStrategyWorkflowId?: any;
    Amount?: number;
    Color?: string;
    Cost?: number;
    CreatedSysDateTime?: string;
    CreatedSysUser?: string;
    DueDate?: string;
    EstablishmentIdentifier?: string;
    ExpectedLpContainerType?: number;
    ExpectedLpLookupCode?: string;
    ExpectedPackageAmount?: number;
    ExpectedPackage?: { Id?: number, Name?: string, ShortName?: string };
    GrossWeight?: number;
    HasChildren?: boolean;
    LicensePlate?: { Id?: number, LookupCode?: string };
    LineNumber?: number;
    Lot?: { Id?: number, LookupCode?: string };
    Marks?: string;
    MaterialAlias?: string;
    Material?: { Id?: number, LookupCode?: string, Name?: string };
    MaterialTransferSourceLineId?: number;
    ModifiedSysDateTime?: string;
    ModifiedSysUser?: string;
    NetWeight?: number;
    Notes?: string;
    OrderId?: number;
    PackageAllocationStrategy?: { EnumName?: string, Id?: number, IsDefault?: boolean, Name?: string };
    PackagedAmount?: number;
    Packaging?: { Id?: number, Name?: string, ShortName?: string };
    ParentLineNumber?: number;
    Price?: number;
    PurchaseOrderIdentifier?: string;
    QualityControlNotes?: string;
    QualityControlRequired?: boolean;
    QualityControlStatus?: string;
    ResidueHoldIdentifier?: string;
    SerialNumber?: { Id?: number, LookupCode?: string };
    Shipment?: { Id?: number, LookupCode?: string };
    ShippingAddressId?: number;
    Size?: string;
    Status?: { Id?: number, Name?: string, ShortName?: string };
    Style?: string;
    TotalCost?: number;
    TotalPrice?: number;
    VendorLot?: { Id?: number, LookupCode?: string };
    WeightTolerancePercentage?: number;
    WeightUom?: { Id?: number, Name?: string, Short_name?: string };
    CustomFields?: $frontendTypes.SalesOrders.CustomField[];
  }
  /**
   * Footprint Order object
   */
  export interface i_order_object {
    AccountId?: number;
    BackOrder?: boolean;
    BillingAddresId?: number;
    CancelThresholdDate?: string;
    ContainsPortalVisibleAttachments?: boolean;
    CreatedSysDateTime?: string;
    CreatedSysUser?: string;
    Currency?: { Id?: number, Label?: string, ShortLabel?: string };
    Exported?: boolean;
    ExternalLabel?: string;
    FulfillmentDate?: string;
    Id?: number;
    IntegrationHubId?: string;
    IntegrationHubSourceId?: string;
    IntegrationHubSourceLookupCode?: string;
    IntegrationHubSourcePlatform?: string;
    LookupCode?: string;
    MasterOrder?: { Id?: number, LookupCode?: string };
    ModifiedSysDateTime?: string;
    ModifiedSysUser?: string;
    Notes?: string;
    OrderClass?: { Id?: number, LookupCode?: string, Name?: string };
    OrderStatus?: { Id?: number, Name?: string, ShortName?: string };
    OutboundPriorityId?: number;
    OwnerReference?: string;
    ParentOrderId?: number;
    PreferredCarrier?: { Id?: number, Name?: string, ScacCode?: string, ShortName?: string };
    PreferredCarrierServiceType?: { Id?: number, Name?: string, ShortName?: string };
    PreferredWarehouse?: { Id?: number, Name?: string };
    Project?: { Id?: number, LookupCode?: string, Name?: string, Owner?: { Id?: number, LookupCode?: string, Name?: string, EnterpriseId?: number } };
    ReadyToExport?: boolean;
    ReadyToExportBy?: string;
    ReadyToExportDate?: string;
    RequestedDeliveryDate?: string;
    ShippingAddress?: { Id?: number };
    ThirdPartyWarehouse?: { Id?: number, Name?: string };
    TotalCost?: number;
    TotalPrice?: number;
    VendorReference?: string;
    OrderLines?: $frontendTypes.SalesOrders.i_order_line_object[];
    ShipmentOrderLookups?: { Order?: { Id?: number }, Shipment?: any }[];
    Shipments?: any[];
    CustomFields?: $frontendTypes.SalesOrders.CustomField[];
  }
}

export namespace $frontendTypes {
  export import Utilities =  Utilities_Types;
  export import SalesOrders = SalesOrders_Types;
}




